<template>
  <div class="main-content">
    <breadcrumb :nameSection="nameSection" :listRoutes="listRoutes"></breadcrumb>

    <div class="form-content">
      <div class="form-content-title">
        <div class="form-content-title-block form-title">
          <div class="form-title-block form-title-principal">
            <span>Órdenes de compra</span>
          </div>

          <!-- <div
            class="form-title-block"
            v-if="$store.state.user.attributes.permissions_keys.includes(8)"
          >
            <b-button v-b-modal.formmodal class="btn btn-primary"
              ><i class="fas fa-plus"></i>Nueva orden</b-button
            >
          </div> -->
        </div>

        <div class="form-content-title-block filter-container">
          <div class="filter-block filter-block-various">
            <label>Buscar por:</label>

            <div class="filter-block-content">
              <select
                id="select-search"
                class="form-control"
                v-model="tableData.filterBy"
                @change="cleanInput()"
              >
                <option value="all">Todos</option>
                <option
                  :value="option.name"
                  v-for="option in filterColumns"
                  :key="option.id"
                >
                  {{ option.label }}
                </option>
              </select>

              <input
                id="search-bar"
                type="search"
                class="form-control"
                v-model="tableData.filterValue"
                placeholder="Buscar..."
                @keyup="getPurchaseOrdersByPage()"
              />
            </div>
          </div>

          <div class="filter-block filter-block-alone">
            <label>Estado:</label>

            <div class="multiselect form-control" id="checkboxes2">
              <!-- @click="showCheckboxes" -->
              <div class="selectBox">
                <select
                  class="kt-form__label"
                  v-model="typeEstado"
                  @change="changeEstadoListOrder(typeEstado)"
                >
                  <option value="1">Todos</option>
                  <option value="2">Activos</option>
                  <option value="3">Cancelados</option>
                </select>
              </div>
            </div>
          </div>
          <div class="filter-bloc filter-block-alone">
            <label>Canal de venta:</label>
            <select
              class="form-control"
              v-model="tableData.store"
              @change="getPurchaseOrdersByPage()"
            >
              <option value="all" selected>Todo</option>
              <option
                value="sendi"
                data-content="<span class='badge badge-info'>Ofertas de Grabr</span>"
              >
                Sendi
              </option>
              <option
                value="enviosusa"
                data-content="<span class='badge badge-warning'>Ofertas no Grabr</span>"
              >
                Envios Usa
              </option>
            </select>
          </div>
          <!-- <div class="filter-bloc filter-block-alone">
            <label>Tipo de orden:</label>
            <select
              class="form-control"
              v-model="tableData.order_type"
              @change="getPurchaseOrdersByPage()"
            >
              <option :value="5" selected>Todo</option>
              <option
                :value="1"
                data-content="<span class='badge badge-info'>Ofertas de Grabr</span>"
              >
                Grabr
              </option>
              <option
                :value="2"
                data-content="<span class='badge badge-warning'>Ofertas no Grabr</span>"
              >
                Direct
              </option>
              <option
                :value="3"
                data-content="<span class='badge badge-warning'>Ofertas no Grabr</span>"
              >
                Linio
              </option>
              <option
                :value="4"
                data-content="<span class='badge badge-warning'>Ofertas no Grabr</span>"
              >
                Meli
              </option>
            </select>
          </div> -->
        </div>

        <div class="filter-bloc" v-if="tableData.order_type === 4">
          <div class="wrap">
            <form action="" class="formulario">
              <div class="radio">
                <span v-if="this.valorRadioButton == true">
                  <input type="radio" id="inicio" />
                  <label for="inicio">Todo</label>
                </span>

                <span v-else-if="this.valorRadioButton == false">
                  <input
                    type="radio"
                    id="todo"
                    :value="null"
                    v-model="tableData.store"
                    @change="getPurchaseOrdersByPage()"
                  />
                  <label for="todo">Todo</label>
                </span>

                <input
                  type="radio"
                  id="electro"
                  :value="'electro'"
                  v-model="tableData.store"
                  @change="getPurchaseOrdersByPage()"
                  @click="cambiarEstado"
                />
                <label for="electro">Electro</label>

                <input
                  type="radio"
                  id="fashion"
                  :value="'fashion'"
                  v-model="tableData.store"
                  @change="getPurchaseOrdersByPage()"
                  @click="cambiarEstado"
                />
                <label for="fashion">Fashion</label>

                <input
                  type="radio"
                  id="kids"
                  :value="'kids'"
                  v-model="tableData.store"
                  @change="getPurchaseOrdersByPage()"
                  @click="cambiarEstado"
                />
                <label for="kids">Kids</label>

                <input
                  type="radio"
                  id="home"
                  :value="'home'"
                  v-model="tableData.store"
                  @change="getPurchaseOrdersByPage()"
                  @click="cambiarEstado"
                />
                <label for="home">Home</label>
                <input
                  type="radio"
                  id="pets"
                  :value="'pets'"
                  v-model="tableData.store"
                  @change="getPurchaseOrdersByPage()"
                  @click="cambiarEstado"
                />
                <label for="pets">Pets</label>
              </div>
            </form>
          </div>
        </div>
      </div>

      <!--circle-spin v-if="is_loading"></circle-spin>-->

      <div class="table-orders">
        <data-table
          :columns="columns"
          :sortKey="sortKey"
          :sortOrders="sortOrders"
          @sort="sortBy"
          v-if="is_loading == false"
        >
          <tbody v-if="purchaseOrders != null && purchaseOrders.length > 0">
            <router-link
              :to="{
                name: 'show-purchase-order',
                params: { id: purchaseOrder.id, orderData: purchaseOrder },
              }"
              v-for="purchaseOrder in diasRestantes"
              :key="purchaseOrder.id"
            >
              <tr>
                <td>
                  <div class="image-table">
                    <img
                      v-if="purchaseOrder.attributes.product_image_url"
                      :src="purchaseOrder.attributes.product_image_url"
                      width="180px"
                      height="260px"
                    />
                    <img
                      v-else
                      src="../../assets/images/image-package.png"
                      width="180px"
                      height="260px"
                    />

                    <!-- <img
                      v-if="
                        purchaseOrder.attributes.product_image_url == null &&
                        purchaseOrder.attributes.is_from_meli_flag
                      "
                      :src="'https://pngimage.net/wp-content/uploads/2018/06/producto-icono-png-3.png'"
                      width="180px"
                      height="260px"
                    />
                    <img
                      v-else-if="
                        purchaseOrder.attributes.product_image_url == null &&
                        purchaseOrder.attributes.is_from_linio_flag
                      "
                      src="/static/img/linio-logo.png"
                      width="180px"
                      height="260px"
                    />
                    <img
                      v-else-if="purchaseOrder.attributes.product_image_url"
                      :src="purchaseOrder.attributes.product_image_url"
                      width="180px"
                      height="260px"
                    />
                    <img
                      v-else
                      :src="'https://pngimage.net/wp-content/uploads/2018/06/producto-icono-png-3.png'"
                      width="180px"
                      height="260px"
                    /> -->
                  </div>

                  <div class="description-title">
                    <span class="description-title-principal">{{
                      purchaseOrder.attributes.product_info
                    }}</span>

                    <div>
                      <span class="code-order system-code"
                        >QTY:{{ purchaseOrder.attributes.product_specimens }} | SB #{{
                          purchaseOrder.id
                        }}
                      </span>

                      <span
                        class="code-order grabr-code"
                        v-if="purchaseOrder.attributes.is_from_linio_flag"
                      >
                        #{{
                          purchaseOrder.attributes.linioOrder.attributes.linio_order_id
                        }}</span
                      >

                      <span
                        class="code-order grabr-code"
                        v-else-if="purchaseOrder.attributes.is_from_meli_flag"
                      >
                        #{{
                          purchaseOrder.attributes.meliOrder.attributes.meli_order_id
                        }}</span
                      >
                      <br />
                      <span
                        :class="
                          purchaseOrder.attributes.status == 10
                            ? 'bg-danger'
                            : 'bg-success'
                        "
                        class="badge badge-primary"
                      >
                        {{
                          purchaseOrder.attributes.status == 10 ? "Cancelada" : "Activa"
                        }}
                      </span>
                      <span
                        class="badge badge-primary bg-success"
                        v-if="purchaseOrder.attributes.type === 2"
                        >{{ purchaseOrder.attributes.store }}</span
                      >
                      <span
                        class="badge badge-primary bg-success"
                        v-if="purchaseOrder.attributes.type === 2"
                      >
                        <span v-if="purchaseOrder.attributes.store==='sendi'">
                          {{ purchaseOrder.attributes.direct_type ===1?'Courier':'Shopper' }}
                        </span>
                          <span v-if="purchaseOrder.attributes.store==='enviosusa'">
                         {{ purchaseOrder.attributes.direct_type ===1?'Lite':'Premium' }}
                        </span>
                      </span>
                      <span
                        class="badge badge-primary bg-primary"
                        v-if="purchaseOrder.attributes.reference_link"
                        >{{ getStore(purchaseOrder.attributes.reference_link) }}</span
                      >
                      <span class="badge badge-primary bg-secondary"
                        >WR -{{ purchaseOrder.attributes.warehouse_admin }}</span
                      >
                    </div>

                    <div
                      v-if="purchaseOrder.attributes.is_from_grabr_flag"
                      class="grabr-des"
                    >
                      <span class="badge badge-primary badge-grabr">Grabr</span>

                      <span
                        class="code-order grabr-code"
                        @click="
                          toGrabrDetail(
                            purchaseOrder.attributes.grabrOrder.attributes
                              .grabr_order_number
                          )
                        "
                        >{{
                          purchaseOrder.attributes.grabrOrder.attributes
                            .grabr_order_number
                        }}</span
                      >
                    </div>

                    <div
                      v-else-if="purchaseOrder.attributes.is_from_linio_flag"
                      class="grabr-des"
                    >
                      <span class="badge badge-primary badge-linio">Linio</span>

                      <!-- <span class="code-order grabr-code" v-b-popover.hover.top="'Codigo del Partner' " @click="toGrabrDetail(purchaseOrder.attributes.grabrOrder.attributes.grabr_order_number)" >{{purchaseOrder.attributes.grabrOrder.attributes.grabr_order_number}}</span> -->
                    </div>

                    <div
                      v-else-if="purchaseOrder.attributes.is_from_meli_flag"
                      class="grabr-des"
                    >
                      <span class="badge badge-primary badge-meli">Mercado libre</span>
                      <span
                        class="badge badge-primary badge-store bg-primary"
                        v-if="
                          purchaseOrder.attributes.meliOrder.attributes.store ===
                          'electro'
                        "
                        >{{ purchaseOrder.attributes.meliOrder.attributes.store }}
                      </span>
                      <span
                        class="badge badge-primary badge-store magenta"
                        v-if="
                          purchaseOrder.attributes.meliOrder.attributes.store === 'kids'
                        "
                        >{{ purchaseOrder.attributes.meliOrder.attributes.store }}
                      </span>
                      <span
                        class="badge badge-primary badge-store brown"
                        v-if="
                          purchaseOrder.attributes.meliOrder.attributes.store ===
                          'fashion'
                        "
                        >{{ purchaseOrder.attributes.meliOrder.attributes.store }}
                      </span>
                      <span
                        class="badge badge-primary badge-store bg-success"
                        v-if="
                          purchaseOrder.attributes.meliOrder.attributes.store === 'home'
                        "
                        >{{ purchaseOrder.attributes.meliOrder.attributes.store }}
                      </span>
                    </div>
                    <br />
                    <span class="font-weight-bold">
                      Tracking: {{ purchaseOrder.attributes.system_tracking_number }}
                    </span>
                  </div>
                </td>

                <!-- <td>
                  <span class="">{{ purchaseOrder.attributes.product_specimens }}</span>
                </td> -->

                <td
                  v-if="
                    purchaseOrder.attributes.origin != undefined &&
                    purchaseOrder.attributes.destination != undefined
                  "
                >
                  <div class="ruta-order-container">
                    <div class="ruta-order-block ruta-order-image">
                      <img src="/static/img/ruta.svg" alt="" />
                    </div>

                    <div class="ruta-order-block">
                      <div class="ruta-order-content">
                        <span>{{ purchaseOrder.attributes.origin.attributes.name }}</span>
                      </div>

                      <div class="ruta-order-content">
                        <span>{{ purchaseOrder.attributes.destination_address }}</span>
                      </div>
                    </div>
                  </div>
                </td>

                <td v-else>
                  <span class="ruta-order">No se ha definido</span>
                </td>

                <td>
                  <div class="order-tag-container">
                    <span>
                      <img src="/static/img/icon-pago-status.png" width="20" alt="" />
                      <span v-if="purchaseOrder.attributes.payed === 1">PENDIENTE</span>
                      <span v-else-if="purchaseOrder.attributes.payed === 2"
                        >EN PROCESO</span
                      >
                      <span v-else-if="purchaseOrder.attributes.payed === 3"
                        >CONFIRMADO</span
                      >
                      <span v-else-if="purchaseOrder.attributes.payed === 10"
                        >RECHAZADO"</span
                      >
                      <span v-else-if="purchaseOrder.attributes.payed === 11"
                        >RECLAMADO</span
                      >
                      <span v-else-if="purchaseOrder.attributes.payed === 12"
                        >RETORNADO</span
                      >
                    </span>

                    <span>
                      <ul>
                        <li>
                          <span>
                            <span
                              v-if="purchaseOrder.attributes.payment_method_flag === 5"
                            >
                              <img
                                v-if="purchaseOrder.attributes.payment_code === null"
                                src="/static/img/statuPagoIcon/PagoCodigo-1.png"
                                width="30"
                                alt=""
                              />
                              <img
                                v-else-if="
                                  purchaseOrder.attributes.payment_code !== null &&
                                  purchaseOrder.attributes.payed !== 3
                                "
                                src="/static/img/statuPagoIcon/PagoCodigo-2.png"
                                width="30"
                                alt=""
                              />
                              <img
                                v-else-if="purchaseOrder.attributes.payed === 3"
                                src="/static/img/statuPagoIcon/PagoCodigo-3.png"
                                width="30"
                                alt=""
                              />
                            </span>
                            <span
                              v-if="purchaseOrder.attributes.payment_method_flag === 2"
                            >
                              <img
                                v-if="
                                  purchaseOrder.attributes.paypalPayment.attributes
                                    .paypal_order_id === null
                                "
                                src="/static/img/statuPagoIcon/PagoCodigo-1.png"
                                width="30"
                                alt=""
                              />
                              <img
                                v-else-if="
                                  purchaseOrder.attributes.paypalPayment.attributes
                                    .paypal_order_id !== null &&
                                  purchaseOrder.attributes.payed !== 3
                                "
                                src="/static/img/statuPagoIcon/PagoCodigo-2.png"
                                width="30"
                                alt=""
                              />
                              <img
                                v-else-if="purchaseOrder.attributes.payed === 3"
                                src="/static/img/statuPagoIcon/PagoCodigo-3.png"
                                width="30"
                                alt=""
                              />
                            </span>
                            <span
                              v-if="purchaseOrder.attributes.payment_method_flag === 3"
                            >
                              <img
                                v-if="
                                  purchaseOrder.attributes.mercadopagoPayment.attributes
                                    .payment_id === null
                                "
                                src="/static/img/statuPagoIcon/PagoCodigo-1.png"
                                width="30"
                                alt=""
                              />
                              <img
                                v-else-if="
                                  purchaseOrder.attributes.mercadopagoPayment.attributes
                                    .payment_id !== null &&
                                  purchaseOrder.attributes.payed !== 3
                                "
                                src="/static/img/statuPagoIcon/PagoCodigo-2.png"
                                width="30"
                                alt=""
                              />
                              <img
                                v-else-if="purchaseOrder.attributes.payed === 3"
                                src="/static/img/statuPagoIcon/PagoCodigo-3.png"
                                width="30"
                                alt=""
                              />
                            </span>
                            <span
                              v-if="purchaseOrder.attributes.payment_method_flag === 4"
                            >
                              <img
                                v-if="
                                  purchaseOrder.attributes.atm_payment.mp_payment_id ===
                                  null
                                "
                                src="/static/img/statuPagoIcon/PagoCodigo-1.png"
                                width="30"
                                alt="" />
                              <img
                                v-else-if="
                                  purchaseOrder.attributes.atm_payment.mp_payment_id !==
                                    null && purchaseOrder.attributes.payed !== 3
                                "
                                src="/static/img/statuPagoIcon/PagoCodigo-2.png"
                                width="30"
                                alt="" />
                              <img
                                v-else-if="purchaseOrder.attributes.payed === 3"
                                src="/static/img/statuPagoIcon/PagoCodigo-3.png"
                                width="30"
                                alt=""
                            /></span>
                            <span
                              v-if="purchaseOrder.attributes.payment_method_flag === 6"
                              >Pago con saldo</span
                            >
                            - Código</span
                          >
                        </li>

                        <li>
                          <img
                            v-if="purchaseOrder.attributes.voucher_link === null"
                            src="/static/img/statuPagoIcon/PagoVaucher-1.png"
                            width="30"
                            alt=""
                          />
                          <img
                            v-else-if="
                              purchaseOrder.attributes.voucher_link !== null &&
                              purchaseOrder.attributes.payed !== 3
                            "
                            src="/static/img/statuPagoIcon/PagoVaucher-3.png"
                            width="30"
                            alt=""
                          />
                          <img
                            v-else-if="purchaseOrder.attributes.payed === 3"
                            src="/static/img/statuPagoIcon/PagoVaucher-2.png"
                            width="30"
                            alt=""
                          />
                          - Voucher
                        </li>
                      </ul>
                    </span>

                    <span>
                      <img src="/static/img/icon-tracking-statu.png" width="20" alt="" />
                      <span
                        v-if="
                          purchaseOrder.attributes.order_tracking_details[
                            purchaseOrder.attributes.order_tracking_details.length - 1
                          ].attributes.status === 1
                        "
                      >
                        EN REVISIÓN</span
                      ><span
                        v-if="
                          purchaseOrder.attributes.order_tracking_details[
                            purchaseOrder.attributes.order_tracking_details.length - 1
                          ].attributes.status === 2
                        "
                      >
                        COMPRADO</span
                      ><span
                        v-if="
                          purchaseOrder.attributes.order_tracking_details[
                            purchaseOrder.attributes.order_tracking_details.length - 1
                          ].attributes.status === 3
                        "
                      >
                        PREPARANDO PARA ENVIAR</span
                      ><span
                        v-if="
                          purchaseOrder.attributes.order_tracking_details[
                            purchaseOrder.attributes.order_tracking_details.length - 1
                          ].attributes.status === 4
                        "
                      >
                        LISTO PARA ENVIAR</span
                      ><span
                        v-if="
                          purchaseOrder.attributes.order_tracking_details[
                            purchaseOrder.attributes.order_tracking_details.length - 1
                          ].attributes.status === 5
                        "
                      >
                        ENVIADO</span
                      ><span
                        v-if="
                          purchaseOrder.attributes.order_tracking_details[
                            purchaseOrder.attributes.order_tracking_details.length - 1
                          ].attributes.status === 6
                        "
                      >
                        LISTO PARA ENTREGAR</span
                      ><span
                        v-if="
                          purchaseOrder.attributes.order_tracking_details[
                            purchaseOrder.attributes.order_tracking_details.length - 1
                          ].attributes.status === 7
                        "
                      >
                        ENTREGADO</span
                      ><span
                        v-if="
                          purchaseOrder.attributes.order_tracking_details[
                            purchaseOrder.attributes.order_tracking_details.length - 1
                          ].attributes.status === 8
                        "
                      >
                        SINIESTRADO</span
                      ><span
                        v-if="
                          purchaseOrder.attributes.order_tracking_details[
                            purchaseOrder.attributes.order_tracking_details.length - 1
                          ].attributes.status === 9
                        "
                      >
                        EN PROCESO DE DEVOLUCIÓN</span
                      ><span
                        v-if="
                          purchaseOrder.attributes.order_tracking_details[
                            purchaseOrder.attributes.order_tracking_details.length - 1
                          ].attributes.status === 10
                        "
                      >
                        RETORNADO AL PROVEEDOR</span
                      >
                    </span>

                    <!-- <span
                      class="order-tag order-init"
                      v-if="
                        purchaseOrder.attributes.status >= 1 &&
                        purchaseOrder.attributes.status <= 3
                      "
                      >Inicializando</span
                    >

                    <span
                      class="order-tag order-process"
                      v-else-if="
                        purchaseOrder.attributes.status > 3 &&
                        purchaseOrder.attributes.status < 10
                      "
                      >En proceso</span
                    >

                    <span
                      class="order-tag order-cancel"
                      v-else-if="purchaseOrder.attributes.status == 10"
                      >Cancelado</span
                    >

                    <span
                      class="order-tag order-message"
                      v-if="
                        purchaseOrder.attributes.status < 10 &&
                        purchaseOrder.attributes.status != 4
                      "
                      >{{ statusArray[purchaseOrder.attributes.status] }}</span
                    >

                    <span
                      class="order-tag order-message"
                      v-if="
                        purchaseOrder.attributes.status < 10 &&
                        purchaseOrder.attributes.status == 4
                      "
                      >{{
                        purchaseOrder.attributes.origin != undefined
                          ? statusArray[purchaseOrder.attributes.status] +
                            " (" +
                            purchaseOrder.attributes.origin.attributes.name +
                            ")"
                          : "Ciudad origen no definida"
                      }}</span
                    >

                    <span class="" v-else>{{
                      cancelledReasonFlagArray[
                        purchaseOrder.attributes.cancelled_reason_flag
                      ]
                    }}</span> -->
                  </div>
                </td>

                <!-- <td>
                  <span class="">{{
                    purchaseOrder.attributes.order_create_date | spanishDate
                  }}</span>
                </td> -->

                <td>
                  <span class="">
                    <img
                      v-if="purchaseOrder.attributes.vouchers_usa.length !== 0"
                      src="/static/img/statuFactura/factura-1.svg"
                      width="50"
                      alt=""
                    />
                    <img
                      v-else
                      src="/static/img/statuFactura/factura-2.svg"
                      width="50"
                      alt=""
                    />
                  </span>
                </td>

                <td>
                  <ul>
                    <li>
                      B:{{ purchaseOrder.attributes.order_create_date | spanishDate }}
                    </li>
                    <li
                      v-if="
                        purchaseOrder.attributes.hasOwnProperty('promised_delivery_date')
                      "
                    >
                      <span>
                        D:
                        {{
                          purchaseOrder.attributes.promised_delivery_date | spanishDate
                        }}
                        |
                        <span
                          class="badge badge-primary bg-success"
                          v-if="purchaseOrder.resultado > 15"
                          >{{ purchaseOrder.resultado }} días</span
                        >
                        <span
                          class="badge badge-primary bg-warning"
                          v-if="
                            purchaseOrder.resultado > 10 && purchaseOrder.resultado <= 15
                          "
                        >
                          {{ purchaseOrder.resultado }} días
                        </span>
                        <span
                          class="badge badge-primary bg-danger"
                          v-if="purchaseOrder.resultado <= 10"
                        >
                          <span v-if="Math.sign(purchaseOrder.resultado) === 1"
                            >{{ purchaseOrder.resultado }} días
                          </span>
                          <span v-if="Math.sign(purchaseOrder.resultado) === -1">
                            Retraso de
                            {{ Math.abs(purchaseOrder.resultado) }} dias</span
                          >
                          <span v-if="Math.sign(purchaseOrder.resultado) === 0">
                            Retraso</span
                          >
                        </span></span
                      >
                    </li>
                    <li v-else>No definido</li>
                  </ul>
                </td>
              </tr>
            </router-link>
          </tbody>

          <tbody v-else>
            <div class="no-results">
              <h1>No se encontraron resultados</h1>
            </div>
          </tbody>
        </data-table>
      </div>
    </div>

    <pagination
      :pagination="pagination"
      @changePagination="getPurchaseOrdersByPage"
      v-if="is_loading == false"
    ></pagination>

    <!-- //////////////////////modal////////////////////// -->
    <b-modal id="formmodal" ref="formmodal" centered hide-footer hide-header>
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">Nueva oferta de compra</h5>
        <button type="button" class="close" aria-label="Close" block @click="hideModal">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" id="modal-body">
        <div class="form-login text-title">
          <div class="form-group">
            <label for class="float-left">Seleccione de donde proviene la oferta</label>
            <select class="form-control form-control-lg" v-model="grabr.id">
              <option
                v-if="$store.state.user.attributes.permissions_keys.includes(6)"
                value="1"
              >
                Órdenes GRABR
              </option>
              <option
                v-if="$store.state.user.attributes.permissions_keys.includes(7)"
                value="2"
              >
                Órdenes DIRECT
              </option>
            </select>
          </div>
          <!-- <div class="check-grabr">
                    <label for class="float-left">
                      Seleccione tipo de subida
                      <i class="far fa-question-circle" data-toggle="tooltip" data-placement="bottom" title="Tooltip "></i>
                    </label>
                    <div class="form-check check-2">
                      <input type="checkbox" class="form-check-input" id="exampleCheck1">
                      <label class="form-check-label" for="exampleCheck1">Subida manual</label>
                    </div>
                    <div class="form-check check-2">
                      <input type="checkbox" class="form-check-input" id="exampleCheck1">
                      <label class="form-check-label" for="exampleCheck1">Subida masiva (Excel)</label>
                    </div>
            </div>-->
        </div>
      </div>
      <div class="modal-footer text-right">
        <router-link
          :to="{
            name: 'add-purchase-order',
            params: { grabr: grabr, oldID: null },
          }"
        >
          <button type="button" class="btn btn-primary">Continuar</button>
        </router-link>
      </div>
    </b-modal>
  </div>
</template>

<script>
import breadcrumb from "@/components/prefab/structures/breadcrumb.vue";
import DataTable from "./DataTable.vue";
import Pagination from "./Pagination.vue";
import axios from "axios";
export default {
  components: { DataTable, Pagination, breadcrumb },
  created() {
    if (!this.$store.state.user.attributes.permissions_keys.includes(6)) {
      this.grabr.id = "2";
    }
    if (this.purchaseOrders == null) {
      this.is_loading = true;
    }
    this.getPurchaseOrders();
  },
  data() {
    // eslint-disable-next-line no-unused-vars
    let statusGroupArray = {
      1: "Todos",
      10: "Inicializando",
      20: "En proceso",
      30: "Cancelado",
      40: "Finalizado",
    };
    // eslint-disable-next-line no-unused-vars
    let statusArray = {
      1: "En evaluación",
      2: "Esperando confirmación de evaluación",
      3: "Completando información adicional",
      4: "En camino a origen",
      5: "En origen y evaluación de recepción",
      6: "Listo para embarcar",
      7: "En embarque",
      8: "Entregado correctamente",
      9: "",
      10: "Cancelado",
    };
    // eslint-disable-next-line no-unused-vars
    let cancelledReasonFlagArray = {
      1: "Por decisión propia",
      2: "Por incidencia de tracking",
    };
    let sortOrders = {};
    let columns = [
      //{ label: 'Imagen', name: 'product_image_url', visible: true },
      { label: "Producto", name: "product_info", visible: true },
      { label: "Proveedor", name: "referent_link", visible: false },
      { label: "Número de orden SB", name: "order_code", visible: false },
      { label: "Código de cliente SB", name: "client_grabr_id", visible: false },
      { label: "Destino", name: "destination", visible: false },
      { label: "Tracking SB", name: "tracking_number", visible: false },

      { label: "ID", name: "id", visible: false },
      { label: "Código Partner", name: "grabr_code", visible: false },
      { label: "Nombre de cliente", name: "client_name", visible: false },
      { label: "DNI Cliente", name: "client_dni", visible: false },
      // { label: "Cant.", name: "product_specimens", visible: true },
      { label: "Ruta", name: "route", visible: true },
      { label: "Estado", name: "status", visible: true },
      { label: "Documentos", name: "documentos", visible: true },
      { label: "Fecha de compra", name: "order_create_date", visible: true },
      // {
      //   label: "Fecha de entrega",
      //   name: "promised_delivery_date",
      //   visible: true,
      // },
    ];
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });
    return {
      typeEstado: "1",
      valorRadioButton: true,
      purchaseOrders: null,
      columns,
      statusGroupArray,
      statusArray,
      cancelledReasonFlagArray,
      sortKey: "promised_delivery_date",
      sortOrders: sortOrders,
      filterKey: "",
      expanded: false,
      tableData: {
        // statusFlag: {
        //   initialize: true,
        //   in_proccess: true,
        //   cancelled: true,
        //   finished: true,
        // },  0: Inicializando, 1: En proceso, 2: Cancelado, 3: Finalizado
        statusFlag: {
          todos: true,
          activos: true,
          cancelados: true,
        },
        draw: 0,
        length: 10,
        status: "",
        orderBy: "promised_delivery_date",
        dir: "desc",
        filterBy: "all",
        page: 1,
        filterValue: null, // no hay ningun valor por el cual filtrar
        order_type: 5, // órdenes de Grabr y no Grabr
        store: "all",
      },
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
      },
      grabr: {
        id: "1",
      },
      is_loading: true,
      nameSection: "Órdenes de compra",
      listRoutes: [{ nameRoute: "Orders", titleRoute: "Órdenes de compra" }],
    };
  },
  methods: {
    changeEstadoListOrder(type) {
      if (type === "1") {
        this.tableData.statusFlag.todos = true;
        this.tableData.statusFlag.activos = true;
        this.tableData.statusFlag.cancelados = true;
        this.getPurchaseOrdersByPage();
      } else if (type === "2") {
        this.tableData.statusFlag.todos = false;
        this.tableData.statusFlag.activos = true;
        this.tableData.statusFlag.cancelados = false;
        this.getPurchaseOrdersByPage();
      } else if (type === "3") {
        this.tableData.statusFlag.todos = false;
        this.tableData.statusFlag.activos = false;
        this.tableData.statusFlag.cancelados = true;
        this.getPurchaseOrdersByPage();
      }
    },
    getStore(link) {
      if (link !== null) {
        var separation1 = link.split(".", 2);
        if (separation1[0] !== "https://www") {
          var separation2 = link.split("//", 3);
          var separation3 = separation2[1].split(".", 1);

          return separation3[0];
        }

        return separation1[1];
      }
      return "Sin store";
    },
    cambiarEstado() {
      this.valorRadioButton = false;
    },

    toGrabrDetail(code) {
      console.log("hacia el detalle de grabr");
      let linkToGrabr = "https://grabr.io/es/grabs/" + code;
      window.location = linkToGrabr;
    },
    showCheckboxes() {
      var checkboxes = document.getElementById("checkboxes");
      if (!this.expanded) {
        checkboxes.style.display = "block";
        this.expanded = true;
      } else {
        checkboxes.style.display = "none";
        this.expanded = false;
      }
      window.addEventListener("click", function (e) {
        if (document.getElementById("checkboxes2").contains(e.target)) {
          checkboxes.style.display = "block";
        } else {
          checkboxes.style.display = "none";
        }
      });
    },
    getPurchaseOrders(url = "", fromPagination = false) {
      // 1: Ver todas las órdenes de compra, 2: Ver todas las órdenes de compra por operador, 3: Ver todas las órdenes de compra por cliente
      console.log("Cargando todas las PurchasOrders");
      this.is_loading = true;
      this.tableData.draw++;
      let permissions = this.$store.state.user.attributes.permissions_keys;
      if (!fromPagination) {
        if (permissions.includes(1)) {
          url = process.env.API_URL + "/api/purchaseOrder/list-orders-all";
        } else if (permissions.includes(2)) {
          url =
            process.env.API_URL +
            "/api/purchaseOrder/" +
            this.$store.state.user.id +
            "/list-orders-by-operator";
        } else if (permissions.includes(3)) {
          url =
            process.env.API_URL +
            "/api/purchaseOrder/" +
            this.$store.state.user.id +
            "/list-orders-by-client";
        } else {
          alert("El usuario no tiene permisos para ver órdenes de compra");
          return;
        }
      }
      console.log("URL: " + url);
      console.log("Viene de una paginación? : " + fromPagination);
      console.log("Table data : ");
      this.tableData.status = this.statusComputed;
      console.log(this.tableData);
      // eslint-disable-next-line no-unreachable
      axios
        .get(url, { params: fromPagination ? {} : this.tableData })
        .then((response) => {
          let data = response.data;
          console.log(data);
          if (this.tableData.draw === data.meta.draw || fromPagination) {
            console.log("there are sync or if from pagination");
            this.purchaseOrders = data.data;
            this.configPagination(data);
            this.is_loading = false;
          } else {
            console.log("out of sync");
            this.is_loading = false;
          }
        })
        .catch((errors) => {
          console.log(errors);
          console.log(errors.response);
          console.log("error");
          // alert('No se obtuvieron resultados')
          this.purchaseOrders = null;
          this.is_loading = false;
          return;
        });
    },
    getPurchaseOrdersByPage(page = 1) {
      // 1: Ver todas las órdenes de compra,
      // 2: Ver todas las órdenes de compra por operador
      // 3: Ver todas las órdenes de compra por cliente
      console.log("getPurchaseOrders");
      this.is_loading = true;
      this.tableData.draw++;
      this.tableData.page = page;

      let permissions = this.$store.state.user.attributes.permissions_keys;
      let url = "";
      if (permissions.includes(1)) {
        url = process.env.API_URL + "/api/purchaseOrder/list-orders-all";
      } else if (permissions.includes(2)) {
        url =
          process.env.API_URL +
          "/api/purchaseOrder/" +
          this.$store.state.user.id +
          "/list-orders-by-operator";
      } else if (permissions.includes(3)) {
        url =
          process.env.API_URL +
          "/api/purchaseOrder/" +
          this.$store.state.user.id +
          "/list-orders-by-client";
      } else {
        // alert('El usuario no tiene permisos para ver órdenes de compra')
        return;
      }
      this.tableData.status = this.statusComputed;

      // eslint-disable-next-line no-unreachable
      axios
        .get(url, { params: this.tableData })
        .then((response) => {
          let data = response.data;

          if (this.tableData.draw === data.meta.draw) {
            console.log("RESPONSE:");

            console.log("there are sync");
            console.log("Table data : ");
            console.log(this.tableData);
            console.log(data);

            console.log("=======================");

            this.purchaseOrders = data.data;
            this.configPagination(data);
            this.is_loading = false;
            console.log("FIN RESPONSE");
          } else {
            console.log("ERROR:");

            console.log("out of sync");

            console.log(this.tableData);
            this.is_loading = false;
            console.log("FIN ERROR");
          }
        })
        .catch((errors) => {
          console.log(errors);
          console.log(errors.response);
          console.log("error");
          // alert('No se obtuvieron resultados')
          this.purchaseOrders = null;
          this.is_loading = false;
          return;
        });
    },
    cleanInput() {
      this.tableData.filterValue = "";
      if (this.tableData.filterBy == "all") {
        this.getPurchaseOrders();
      }
    },
    configPagination(data) {
      this.pagination.lastPage = data.meta.last_page;
      this.pagination.currentPage = data.meta.current_page;
      this.pagination.total = data.meta.total;
      this.pagination.lastPageUrl = data.links.last;
      this.pagination.nextPageUrl = data.links.next;
      this.pagination.prevPageUrl = data.links.prev;
      this.pagination.from = data.meta.from;
      this.pagination.to = data.meta.to;
      this.pagination.perPage = this.tableData.length;
    },
    sortBy(key) {
      console.log("entro al sort", key);
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableData.orderBy = this.sortKey;
      /* this.tableData.orderBy = this.getIndex(this.columns, 'name', key) */
      console.log(
        "tableData.orderBy",
        this.tableData.orderBy,
        "tableData.dir",
        this.tableData.dir,
        this.sortOrders[key]
      );
      this.tableData.dir = this.sortOrders[key] === 1 ? "asc" : "desc";
      console.log(
        "tableData.orderBy",
        this.tableData.orderBy,
        "tableData.dir",
        this.tableData.dir
      );
      this.getPurchaseOrders();
      console.log("paso la peticion api");
    },
    getIndex(array, key, value) {
      return array.findIndex((i) => i[key] === value);
    },
    hideModal() {
      this.$refs.formmodal.hide();
    },
    // toDetailView(data) {
    //   console.log(data)
    //   this.$router.push({
    //     name: 'show-purchase-order',
    //     params: { id: data.id, orderData: data }
    //   })
    // }
  },
  computed: {
    diasRestantes() {
      let fechaEntrega = this.purchaseOrders;

      fechaEntrega.forEach((data) => {
        let fechaEntrega = data.attributes.promised_delivery_date;
        let fecha = new Date();
        let fechaini = new Date(fechaEntrega);
        let diff = fechaini.getTime() - fecha.getTime();
        let diasRestantes = Math.round(diff / (1000 * 60 * 60 * 24));
        data.resultado = diasRestantes;
      });

      return fechaEntrega;
    },
    filterColumns() {
      // let activeFilterColumns = [
      //   "product_info",
      //   "destination",
      //   "order_code",
      //   "tracking_number",
      //   "grabr_code",
      //   "client_name",
      //   "client_dni",
      //   "client_grabr_id",
      //   "id",
      // ];

      let activeFilterColumns = [
        "product_info",
        "referent link",
        "order_code",
        "client_grabr_id",
        "destination",
        "tracking_number",
      ];
      return this.columns.filter((i) => activeFilterColumns.indexOf(i.name) > -1);
    },
    statusComputed() {
      console.log("statuscomputed");
      return JSON.stringify([
        this.tableData.statusFlag.todos,
        this.tableData.statusFlag.activos,
        this.tableData.statusFlag.cancelados,
      ]);
    },
  },
};
</script>

<style>
.daysLeft {
  position: absolute;
  padding-top: 40px;
}

.magenta {
  background: #c72ac7;
}
.brown {
  background: #6d4c41;
}
/* ----- ----- ----- ----- */

.formulario {
  /* --------------------------------------- */
  /* ----- Radio Button */
  /* --------------------------------------- */
  /* --------------------------------------- */
  /* ----- Checkbox */
  /* --------------------------------------- */
}
.formulario h2 {
  font-size: 16px;
  color: #001f3f;
  margin-bottom: 20px;
  margin-left: 20px;
}
.formulario .radio label,
.formulario .checkbox label {
  display: inline-block;
  cursor: pointer;
  position: relative;
  padding: 5px 15px 5px 51px;
  font-size: 1em;
  border-radius: 5px;
  -webkit-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
.formulario .radio label:hover,
.formulario .checkbox label:hover {
  background: rgba(240, 235, 235, 0.1);
}
.formulario .radio label:before,
.formulario .checkbox label:before {
  content: "";
  display: inline-block;
  width: 17px;
  height: 17px;
  position: absolute;
  left: 15px;
  border-radius: 50%;
  background: none;
  border: 3px solid;
}
.formulario input[type="radio"] {
  display: none;
}
.formulario input[type="radio"]:checked + label:before {
  display: none;
}
.formulario input[id="todo"]:checked + label {
  padding: 5px 15px;
  background: #b3a72b;
  border-radius: 2px;
  color: #fff;
}
.formulario input[id="electro"]:checked + label {
  padding: 5px 15px;
  background: #007bff;
  border-radius: 2px;
  color: #fff;
}
.formulario input[id="fashion"]:checked + label {
  padding: 5px 15px;
  background: #6d4c41;
  border-radius: 2px;
  color: #fff;
}
.formulario input[id="kids"]:checked + label {
  padding: 5px 15px;
  background: #c72ac7;
  border-radius: 2px;
  color: #fff;
}

.formulario input[id="home"]:checked + label {
  padding: 5px 15px;
  background: #157a15;
  border-radius: 2px;
  color: #fff;
}
.formulario input[id="pets"]:checked + label {
  padding: 5px 15px;
  background: #e96210;
  border-radius: 2px;
  color: #fff;
}

#inicio + label {
  padding: 5px 15px;
  background: #b3a72b;
  border-radius: 2px;
  color: #fff;
}

.formulario input[id="inicio"] + label:before {
  display: none;
}
/*# sourceMappingURL=estilos.css.map */
</style>



// WEBPACK FOOTER //
// OrderTable.vue?50db847e